import React, { FC, useMemo } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { htmlToPlainText } from "./htmlToPlainText";

interface ExpandedBio {
  bio: string;
}

const useStyles = makeStyles(() => ({
  bio: {
    fontSize: 12,
    color: "#858997",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}));

export const ExpandedBio: FC<ExpandedBio> = ({ bio }) => {
  const classes = useStyles();
  const plainBio = useMemo(() => htmlToPlainText(bio), [bio]);

  return <div className={classes.bio}>{plainBio}</div>;
};
